import { render, staticRenderFns } from "./corresponsalia-cuadre-detalle.vue?vue&type=template&id=56b0a6bb&scoped=true&"
import script from "./corresponsalia-cuadre-detalle.vue?vue&type=script&lang=js&"
export * from "./corresponsalia-cuadre-detalle.vue?vue&type=script&lang=js&"
import style0 from "./corresponsalia-cuadre-detalle.vue?vue&type=style&index=0&id=56b0a6bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0a6bb",
  null
  
)

export default component.exports